<app-auth-shell
  title="Set a new password"
  subtitle="Your account has a temporary password. Choose a new one to continue."
>
  <form [formGroup]="form" (ngSubmit)="submit()" class="auth-form">
    <mat-form-field appearance="outline">
      <mat-label>Current password</mat-label>
      <input matInput type="password" formControlName="oldPassword" autocomplete="current-password" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>New password</mat-label>
      <input matInput type="password" formControlName="newPassword" autocomplete="new-password" />
      @if (form.controls.newPassword.invalid && form.controls.newPassword.touched) {
        <mat-error>Must be at least 8 characters</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Confirm new password</mat-label>
      <input matInput type="password" formControlName="confirmPassword" autocomplete="new-password" />
      @if (form.errors?.['mismatch'] && form.controls.confirmPassword.touched) {
        <mat-error>Passwords do not match</mat-error>
      }
    </mat-form-field>

    @if (errorMessage(); as message) {
      <p class="auth-error">{{ message }}</p>
    }

    <button mat-flat-button color="primary" type="submit" [disabled]="loading()" class="auth-submit">
      @if (loading()) {
        <mat-spinner diameter="20" />
      } @else {
        Change Password
      }
    </button>
  </form>
</app-auth-shell>
